import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UIState {
  backdropOpen: boolean;
}

const initialState: UIState = {
  backdropOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showBackdrop: (state) => {
      state.backdropOpen = true;
    },
    hideBackdrop: (state) => {
      state.backdropOpen = false;
    },
    setBackdrop: (state, action: PayloadAction<boolean>) => {
      state.backdropOpen = action.payload;
    },
  },
});

export const { showBackdrop, hideBackdrop, setBackdrop } = uiSlice.actions;

export default uiSlice.reducer;
